import { render, staticRenderFns } from "./Selfreg.vue?vue&type=template&id=7a9d7c30&scoped=true&"
import script from "./Selfreg.vue?vue&type=script&lang=js&"
export * from "./Selfreg.vue?vue&type=script&lang=js&"
import style0 from "./Selfreg.vue?vue&type=style&index=0&id=7a9d7c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d7c30",
  null
  
)

export default component.exports